import {Footer} from "@/components/layouts/main/Footer";
import {RootHeader} from "@/components/layouts/main/RootHeader";
import {HeroVideo} from "@/pages/common/Home/components/HeroVideo";
import {ScrollBtn} from "@/pages/common/Home/components/ScrollBtn";

import {useEffect, useState} from "react";

import {Outlet, useLocation} from "react-router-dom";

/** Shell лендинга: хедер/hero/outlet/футер. Страницы — дочерние <Route> в App (nested routing). */
export const HomeShell = () => {
  const location = useLocation();

  const [isScrollBtnVisible, setScrollBtnVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({top: 0, behavior: "smooth"});
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 950) {
        setScrollBtnVisible(true);
      } else {
        setScrollBtnVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <RootHeader />

      <HeroVideo
        hero
        top={!location.pathname.includes("overview") ? "-550" : "-260"}
      />

      <Outlet />

      {isScrollBtnVisible && <ScrollBtn click={scrollToTop} />}

      <Footer />
    </>
  );
};
